import React from "react";
import {
  Navbar,
  NavbarBrand,
  NavbarContent,
  NavbarItem,
  // Link,
  // Input,
} from "@heroui/react";
import { useDisclosure } from "@heroui/react";
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  User,
} from "@heroui/react";

import AccountSidebar from "./AccountSidebar";
// import { useNavigate, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { logLogout } from "../../utils/activityLogger";
import { UserIcon ,DownArrowIcon } from "../../components/HeaderSidebarIcons";
// import { useBalance } from "../../contexts/BalanceContext";

export default function Header() {

  // const { balance, exposure, resetWallet } = useBalance();

  const {
    isOpen: isSidebarOpen,
    // onOpen: openSidebar,
    onOpenChange: onSidebarChange,
  } = useDisclosure();

  const closeSidebar = () => onSidebarChange(false);

  const navigate = useNavigate();
  // const location = useLocation();

  const flushItem = async () => {
    await logLogout();
    localStorage.clear();
    navigate("/login");
  };

  return (
    <div>
      <div className="w-full">
        <Navbar
          className="bg-matka_black"
          classNames={{
            wrapper: "max-w-full px-6 pb-1 mt-3 mb-3", // Make wrapper full width with padding
            base: "justify-start", // Start alignment for the base container
          }}
        >
          <NavbarBrand className="mr-10 py-2">
            <div className="flex items-center gap-10">
              <a href="/user/home">
                {" "}
                <div className="flex gap-1">
                  <img src="/img/matka-g.svg" alt="Logo" width={220} />
                  {/* <span className="text-white text-lg font-bold uppercase">
                    Matka
                  </span> */}
                </div>
              </a>
            </div>
            
          </NavbarBrand>
          <div className="sm:hidden">
            <button
              type="button"
              className="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-white hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
              onClick={() => onSidebarChange(true)}
            >
              <span className="text-xl">☰</span>
            </button>
          </div>

          <NavbarContent
            className="hidden sm:flex ml-auto gap-6 mr-2"
            justify="end"
          >
             {/* <NavbarItem>
              <a className="flex items-center gap-4 text-white" onClick={() => navigate('/message')} style={{ cursor: 'pointer' }}>Page</a>
            </NavbarItem> */}
            <NavbarItem>
              <div className="flex items-center gap-4">
                <Dropdown placement="bottom-start">
                  <DropdownTrigger>
                    <button className="transition-transform ">
                      <div className="flex items-center gap-3 text-left">
                        

                        <div className="text-sm text-white text-end font-bold">
                          <div className="text-matka_yellow tracking-wider">{localStorage.getItem("name") || "user"}</div>
                          <div className="text-xs font-bold py-1">
                            {/* Balance: <span className="font-medium text-sm">{balance} / </span>{" "} */}
                            {/* Exposure: <span className="font-medium text-sm">{exposure}</span> */}
                          </div>
                        </div>
                        <User
                          as="div"
                          avatarProps={{
                            isBordered: true,
                            icon: <UserIcon />,
                          }}
                        />
                        <DownArrowIcon/>
                      </div>
                    </button>
                  </DropdownTrigger>

                  <DropdownMenu aria-label="User Actions" variant="flat">
                    <DropdownItem
                      key="logout"
                      color="danger"
                      className="bg-matka_black text-white text-center"
                      onClick={() => flushItem()}
                    >
                      Log Out
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
            </NavbarItem>
          </NavbarContent>
        </Navbar>
      </div>
      <AccountSidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
    </div>
  );
}
